var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('horizontal-navbar'),_c('h2',[_vm._v(_vm._s(_vm.$t('faq.title')))]),_c('faq')],1)}
var staticRenderFns = []

export { render, staticRenderFns }